export default __webpack_public_path__ + "static/media/spaceLayer2.ad03e8ae.png";